var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.renderTd)?_c('td',{class:_vm.classNames,domProps:{"innerHTML":_vm._s(_vm.getFormattedValue())}}):_c('span',{class:_vm.classNames,domProps:{"innerHTML":_vm._s(_vm.getFormattedValue())}})}
var staticRenderFns = []

export { render, staticRenderFns }